import { render, staticRenderFns } from "./AppList.vue?vue&type=template&id=3b2128e3&scoped=true"
import script from "./AppList.vue?vue&type=script&lang=ts"
export * from "./AppList.vue?vue&type=script&lang=ts"
import style0 from "./AppList.vue?vue&type=style&index=0&id=3b2128e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2128e3",
  null
  
)

export default component.exports